var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinearIconGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6322_7409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8205 3.16637C11.6112 -0.0429165 6.41566 -0.0554109 3.19092 3.12891L14.858 14.7959C18.0423 11.5712 18.0297 6.37566 14.8205 3.16637Z",
    fill: "#555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.54492 5.43421L12.5528 16.4421C13.1239 16.1685 13.67 15.8254 14.1785 15.4127L2.57433 3.80859C2.16169 4.31703 1.81856 4.86314 1.54492 5.43421Z",
    fill: "#555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45109 17.2366L0.75 8.53559C0.791342 7.79722 0.931436 7.06335 1.17029 6.35547L11.6312 16.8163C10.9233 17.0552 10.1895 17.1953 9.45109 17.2366Z",
    fill: "#555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.15345 14.8334C1.76272 13.4426 0.972307 11.6789 0.782227 9.86426L8.12263 17.2046C6.3079 17.0145 4.54418 16.2241 3.15345 14.8334Z",
    fill: "#555"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6322_7409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinearIconGray);
export default __webpack_public_path__ + "static/media/linear-icon-gray.a6fd1e82d29feea76641bab63444a345.svg";
export { ForwardRef as ReactComponent };